import { Col, Row, Card, Divider, Typography, Space, Button } from "antd";
import { useState } from "react";
import { ColorsCard } from "./ColorsCard";
const ColorsCardList = ({
    leftColor = "#FFF7D9",
    rightColor = "#E5FFE3",
    rowContentFontCount = 2,
    rowMoreInfoFontCount = 3,
    cardListTitle = "標題",
    cardDatas = [
        {

        },
        {

        },
        {

        },
        {

        },
    ]
}) => {
    
    return (
        <Row>
            <Col span={24}>
                <Row gutter={[4, 4]}>
                    <Space>
                        <Col>
                            <div
                                style={{
                                    color:"#4F85DD",
                                    fontSize:"1.4rem",
                                    fontWeight:'bold',
                                    writingMode: "vertical-lr"
                                }}
                            >
                               {cardListTitle}
                            </div>
                        </Col>
                        <Col span={24}>
                            <Row gutter={[8, 8]} >
                                {cardDatas.map((value) => {
                                    return (
                                        <Col>
                                            <ColorsCard
                                            leftColor = {leftColor}
                                            rightColor = {rightColor}

                                            rowContentFontCount ={rowContentFontCount}
                                            rowMoreInfoFontCount = {rowMoreInfoFontCount}
                                            {...value}
                                            />
                                        </Col>
                                    )
                                })}
                            </Row>
                        </Col>
                    </Space>

                </Row>
            </Col>
        </Row>
    )
}

export { ColorsCardList }